<template>
  <div class="container">
    <div class="columns is-mobile">
      <div class="column is-four-fifth">
        <h1 class="title is-size-4-mobile">
          {{ $t("Offers management") }} ({{ offerIds.length }})
        </h1>
      </div>
      <div class="column is-one-fifth">
        <a
          class="button is-primary is-outlined is-pulled-right"
          :disabled="!isAdmin"
          @click="createNewDraftOfferId"
        >
          <span class="icon is-small"> <i class="fa fa-plus"></i> </span>
          <span>{{ $t("Add offer") }}</span>
        </a>
      </div>
    </div>
    <offer-row
      v-for="offerId in offerIds"
      :key="offerId"
      :selected="scrollToOfferId == offerId"
      :offerId="offerId"
      @removed="removeDraftOfferId(offerId)"
      :errors="errors[offerId]"
      :isDraft="draftOfferIds.includes(offerId)"
    />
  </div>
</template>

<script>
import { state, actions } from "@/store"
import OfferRow from "@/components/settings/offer-row"
import { offerScheduler } from "@/utils"

export default {
  name: "offer-management",
  components: { OfferRow },
  props: ["selectedOfferId"],
  data() {
    return {
      draftOfferIds: [],
      scrollToOfferId: this.selectedOfferId
    }
  },
  computed: {
    offerIds() {
      const draftOfferIds = this.draftOfferIds.filter(
        id => !state.project.data.offers[id]
      )
      return Object.keys(state.project.data.offers).concat(draftOfferIds)
    },
    offers() {
      return state.project.data.offers
    },
    isAdmin() {
      return state.isAdmin
    },
    errors() {
      const errors = []
      Array.from(Array(state.project.data.screens).keys()).forEach(scr =>
        this.validateScreen(scr, errors)
      )
      return errors
    }
  },
  methods: {
    createNewDraftOfferId() {
      const newId = actions.generateOfferId()
      this.draftOfferIds.push(newId)
      this.scrollToOfferId = newId
    },
    removeDraftOfferId(offerId) {
      this.draftOfferIds = this.draftOfferIds.filter(id => id !== offerId)
    },
    validateScreen(screenId, errors) {
      this.validateTimeConflicts(screenId, errors)
      this.validateAlwaysActive(screenId, errors)
    },
    validateAlwaysActive(screenId, errors) {
      const screenAlwaysActiveOfferIds = Object.keys(this.offers).filter(
        offerId =>
          this.isOfferScreenEnabled(screenId, offerId) &&
          this.isOfferAlwaysActive(offerId)
      )
      if (screenAlwaysActiveOfferIds.length < 2) {
        return
      }
      screenAlwaysActiveOfferIds.forEach(offerId => {
        const otherOfferIds = screenAlwaysActiveOfferIds.filter(
          id => id !== offerId
        )
        if (otherOfferIds.length === 0) {
          return
        }
        const text =
          'Other offers {1} assigned to Screen {0} have "Always presented" option ON'
        this.addError(errors, screenId, text, offerId, otherOfferIds)
      })
    },
    validateTimeConflicts(screenId, errors) {
      const usedSchedulingForScreen = this.getSchedulingsForActiveScreen(
        screenId,
        state.project.data.scheduling
      )
      if (!usedSchedulingForScreen) {
        return
      }
      const rangesOverlappingOffers = offerScheduler.getRangesOverlappingOffers(
        usedSchedulingForScreen,
        state.project.data.schedulingConf
      )
      Object.entries(rangesOverlappingOffers)
        .filter(([offerId]) => !this.isOfferAlwaysActive(offerId))
        .forEach(([offerId, overlappingOfferIds]) => {
          const rangesOverlappingOfferIds = overlappingOfferIds.filter(
            overlappingOfferId => !this.isOfferAlwaysActive(overlappingOfferId)
          )
          if (rangesOverlappingOfferIds.length === 0) {
            return
          }
          const text =
            "Other offers {1} are assigned to Screen {0} at the same time"
          this.addError(
            errors,
            screenId,
            text,
            offerId,
            rangesOverlappingOfferIds
          )
        })
    },
    getSchedulingsForActiveScreen(screenId, allScheduling) {
      if (Object.keys(allScheduling).length === 0) {
        return
      }
      return Object.keys(this.offers)
        .filter(offerId => this.isOfferScreenEnabled(screenId, offerId))
        .reduce((scheduling, offerId) => {
          scheduling[offerId] = allScheduling[offerId]
          return scheduling
        }, {})
    },
    addError(errors, screenId, text, offerId, overlappingOffers) {
      errors[offerId] = [
        ...(errors[offerId] ? errors[offerId] : []),
        { text, screenId, overlappingOffers }
      ]
    },
    isOfferScreenEnabled(screenId, offerId) {
      return this.offers[offerId].conf.screens[screenId]
    },
    isOfferAlwaysActive(offerId) {
      return (
        state.project.data.scheduling[offerId] &&
        state.project.data.scheduling[offerId].alwaysActive
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
